import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-204">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="flex justify-between h-16 items-center" data-id="element-206">
          <div className="flex-shrink-0 flex items-center" data-id="element-207">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mGHYUh8bFRbFqAvk8BmDot/pasted-image-Photoroom.png" alt="日本清掃センター" className="h-96 w-auto object-cover" data-id="element-208" />
          </div>
          <div className="hidden lg:ml-8 lg:flex lg:items-center lg:space-x-6" data-id="element-209">
            <a href="#services" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-210">
              サービス
            </a>
            <a href="#benefits" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-211">
              特徴
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-212">
              料金
            </a>
            <a href="#faq" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-213">
              よくある質問
            </a>
            <a href="#company" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-214">
              会社情報
            </a>
            <a href="#contact" className="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-md text-sm font-medium flex items-center" data-id="element-215">
              お問い合わせ
            </a>
          </div>
          <div className="lg:hidden" data-id="element-216">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" data-id="element-217">
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-218" /> : <MenuIcon className="h-6 w-6" data-id="element-219" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white border-t" data-id="element-220">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-221">
            <a href="#services" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600" data-id="element-222">
              サービス
            </a>
            <a href="#benefits" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600" data-id="element-223">
              特徴
            </a>
            <a href="#pricing" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600" data-id="element-224">
              料金
            </a>
            <a href="#faq" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600" data-id="element-225">
              よくある質問
            </a>
            <a href="#company" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600" data-id="element-226">
              会社情報
            </a>
            <a href="#contact" className="block px-3 py-2 text-base font-medium bg-blue-600 text-white hover:bg-blue-700 rounded-md mt-2" data-id="element-227">
              お問い合わせ
            </a>
          </div>
        </div>}
    </header>;
};
export default Header;